import * as React from 'react'
import {ReactNode} from 'react'
import {useTranslation} from 'react-i18next'
import joinClassNames from '../../../helpers/joinClassNames'

type Props = {
    required?: boolean
    children?: ReactNode
    className?: string
}

const FormLegend = ({required, children, className}: Props) => {
    const {t} = useTranslation()

    return (
        <div className={joinClassNames('has-text-grey-light', 'is-size-7', 'has-text-left', className)}>
            {required && <p>{t('form-legend_required-field')}</p>}
            {children}
        </div>
    )
}

export default FormLegend
